import React, { useState } from 'react';

import Head from 'next/head';
import { useRouter } from 'next/router';

import axios from 'axios';

import Error from '../_error';

import TopNav from '../../components/TopNav';
import BottomNav from '../../components/BottomNav';
import Loading from '../../components/Loading';
import DesktopProfile from '../../components/business/DesktopProfile';
import MobileProfile from '../../components/business/MobileProfile';
import ContactDialog from '../../components/business/ContactDialog';
import AutoRepair from '../../components/structured-data/AutoRepair';


function BusinessProfile({ data, statusCode }) {
  const router = useRouter();
  const [open, setOpen] = useState(false);

  if (statusCode) {
    return <Error statusCode={statusCode} />
  }

  if (router.isFallback) {
    return <Loading />
  }

  const description = data.description ? data.description.length > 170 ? data.description.slice(0, 165) : data.description : `${ data.name } is located at ${ data.address }.${ data.telephone ? 'You can contact them at ' + data.telephone : ''}`;
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return <>
    <Head>
      <title>{data.name} | MechanicBuddy</title>
      <meta
        name="description"
        content={description}
      />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://www.mechanicbuddy.co.za${router.asPath}`} />
      <meta property="og:title" content={`${data.name} | MechanicBuddy`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={data.logo ? data.logo + '?w=240' : 'https://www.mechanicbuddy.co.za/logos/mechanicbuddy-text-logo-square.jpg'} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:url" content={`https://www.mechanicbuddy.co.za${router.asPath}`} />
      <meta property="twitter:title" content={`${data.name} | MechanicBuddy`} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={data.logo ? data.logo + '?w=240' : 'https://www.mechanicbuddy.co.za/logos/mechanicbuddy-text-logo-square.jpg'} />

      <link rel="canonical" href={`https://www.mechanicbuddy.co.za${router.asPath}`} />
      <AutoRepair data={data} />
    </Head>

    <TopNav />
    
    <DesktopProfile data={data} handleClickOpen={handleClickOpen} />

    <MobileProfile data={data} handleClickOpen={handleClickOpen} />

    <BottomNav />

    <ContactDialog data={data} open={open} handleClose={handleClose} />
  </>;
}


// This also gets called at build time
export async function getStaticProps({ params }) {
  const props = await axios(
    `${process.env.DOMAIN}/content/business/${params.slug}/`
  )
  .then(result => {
    return {
      data: result.data,
      statusCode: null
    }
  })
  .catch(error => {
    return {
      data: null,
      statusCode: error.response.status
    }
  });

  if (props.statusCode === 404) {
    return {
      notFound: true
    }
  }

  return {
    props,
    revalidate: 86400, // In seconds
  }
}

export default BusinessProfile;


export async function getStaticPaths() {
  const response = await axios(`${process.env.DOMAIN}/api/v2/business-slugs/`);

  const paths = response.data.map(slug => ({
    params: {
      slug
    }
  }))

  return {
    paths,
    fallback: 'blocking'
  };
}
